import { ColDef, ITooltipParams } from 'ag-grid-enterprise';
import { LinkedDocument } from '~/api/def/endpoints/document/documentLinkedDocumentsEndpoint';
import { LivenessTagCellAg } from '../cellRenderers/LivenessTagCellAg';
import { RestatedTagCellAg } from '../cellRenderers/RestatedTagCellAg';
import { InvestorCellAg } from '../cellRenderers/InvestorCellAg';

export const colDefsLinkedDocumentsTable: ColDef<LinkedDocument>[] = [
  {
    field: 'originalName',
    headerName: 'Name',
    sortable: true,
    cellClass: 'flex align-items-center justify-content-left',
    type: 'w120',
    filter: true,
  },
  {
    field: 'type',
    headerName: 'Agreement Type',
    sortable: true,
    filter: true,
    tooltipField: 'type',
    tooltipValueGetter: (p: ITooltipParams) => p.value,
    cellClass: 'flex align-items-center',
  },
  {
    field: 'liveness',
    cellRenderer: LivenessTagCellAg,
    suppressHeaderMenuButton: true,
    headerName: 'Status',
    maxWidth: 120,
    sortable: true,
    cellClass: 'flex align-items-center justify-content-center',
    filter: true,
  },
  {
    field: 'restated',
    headerName: 'Restated',
    sortable: true,
    filter: true,
    maxWidth: 120,
    cellClass: 'flex align-items-center justify-content-center',
    suppressHeaderMenuButton: true,
    cellRenderer: RestatedTagCellAg,
  },
  {
    field: 'investorName',
    headerName: 'Investor',
    cellClass: 'flex align-items-center justify-content-center',
    sortable: true,
    filter: true,
    tooltipField: 'investorName',
    cellRenderer: InvestorCellAg,
  },
  {
    field: 'admissionDate',
    filter: 'agDateColumnFilter',
    headerName: 'Admission Date',
    cellClass: 'flex align-items-center',
    sortable: true,
    resizable: false,
  },
];
